import React, { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Header } from 'formlabs-web-components/Type';
import { Spinner } from 'formlabs-web-components/Navigation';
import { MarketoForm, FormContext, Message } from '../form-builder';

import './NewsLetterSignUp.module.css';

const FormContent = ({ isSidebar }) => {
  const { t } = useTranslation();
  const { formId, isSubmitting, successMessage } = useContext(FormContext);

  if (successMessage) {
    return (
      <div styleName="submitted">
        <span>{successMessage}</span>
        <i className="fl-baseline-check_circle_outline-24px" />
      </div>
    );
  }

  return (
    <Fragment>
      <input
        type="email"
        name="Email"
        placeholder={t('Enter email')}
        title={t('Email')}
        aria-label={t('Email')}
        aria-required="true"
        required
      />

      {isSubmitting && (
        <span styleName="submitting">
          <Spinner size={3} color={isSidebar ? '#000' : '#fff'} />
        </span>
      )}

      {!isSubmitting && (
        <button type="submit" form={formId}>
          {isSidebar ? (
            <span>{t('Sign Up')}</span>
          ) : (
            <Fragment>
              <span styleName="visually-hidden">{t('Sign Up')}</span>
              <i className="fl-arrow-right" aria-hidden="true" />
            </Fragment>
          )}
        </button>
      )}

      <Message type="error" />
    </Fragment>
  );
};

const NewsletterSignUp = ({ layoutType }) => {
  const { t } = useTranslation();
  const isSidebar = layoutType === 'sidebar';
  const props = {
    name: 'Newsletter_Signup',
    errorMessage: t('There was an error signing up, please try again.'),
    successMessage: t('Thanks for your submission.'),
    trackingLabel: 'Newsletter Subscribed',
    analyticsTrackMapping: { email: 'Email' },
    analyticsIdentifyMapping: {
      userId: 'Email',
      traits: { email: 'Email' }
    },
    marketoOptions: {
      munchkinId: '060-UIG-504',
      baseUrl: 'https://app-sj15.marketo.com',
      formId: process.env.RAZZLE_CMS_SITE === 'dental' ? '1575' : '1042'
    }
  };

  return (
    <div styleName={`newsletter-${layoutType}`}>
      {isSidebar && (
        <Header level={6} displayAs={6} weight={400}>
          {t('Sign up for our newsletter')}
        </Header>
      )}
      <MarketoForm {...props}>
        <FormContent isSidebar={isSidebar} />
      </MarketoForm>
    </div>
  );
};

export default NewsletterSignUp;
